export default __webpack_public_path__ + "static/media/freshDale.72f88761.png";